import { useMutation } from '@tanstack/react-query';
// entities/listing barrel은 지도 컴포넌트(@react-google-maps)까지 재수출하므로 직접 경로로 import (엔트리 번들 경량화)
import { useGetListing } from 'entities/listing/api/query';
import { DEFAULT_MAX_DEPOSIT } from 'shared/constants';

import type { CommercialArea } from '../types';
import { postGuideEmailRecipients } from './service';

export const usePostGuideEmailRecipients = () => {
  return useMutation({
    mutationFn: (request: { email: string }) => postGuideEmailRecipients(request),
  });
};

/**
 * Fetches popular listings for a given region sorted by view count
 * Returns top 12 listings
 */
export const usePopularListings = (region: CommercialArea) => {
  return useGetListing({
    searchParam: {
      whereType: 'COMMERCIAL_AREA',
      whereValue: region,
      isViewAll: true,
      minDeposit: 0,
      maxDeposit: DEFAULT_MAX_DEPOSIT,
      sortType: 'VIEWS_DESC',
    },
  });
};

/**
 * Fetches budget-friendly listings under 500K monthly rent
 * Returns top 11 newest listings
 */
export const useBudgetListings = () => {
  return useGetListing({
    searchParam: {
      minBudget: 0,
      maxBudget: 500000,
      minDeposit: 0,
      maxDeposit: DEFAULT_MAX_DEPOSIT,
      isViewAll: true,
      sortType: 'CREATED_AT_DESC',
    },
  });
};
